<template>
	<div class="myAccountSettings">
		<v-sheet class="pa-5">
			<v-switch
					v-model="christmas"
					inset
					label="Christmas animations"
			></v-switch>
		</v-sheet>
		<theme-toggle></theme-toggle>
	</div>
</template>

<script>
import ThemeToggle from "@/shared/ThemeToggle/ThemeToggle.vue";

export default {
	name: "AccountTabMySettings",
	components: { ThemeToggle },
	data() {
		return {
			christmas: true,
		};
	},
	methods: {
		onSelect({ value }, key) {
			this[key] = value;
		},

	}
};
</script>

<style scoped lang="scss">
.myAccountSettings {
	.rowSet {
		display: flex;
		gap: 8px;
		text-align: center;
		.label {
			display: flex;
			align-items: center;
		}
	}
}

</style>
